interface ResolveCatalogRouteSlugsArgs {
    routeCity?: string
    routeFilter?: string
    filter?: string
}

export const resolveCatalogRouteSlugs = ({
    routeCity,
    routeFilter,
    filter,
}: ResolveCatalogRouteSlugsArgs): { citySlug?: string; filterSlug?: string } => {
    const [cityFromFilter, slugFromFilter] = filter?.includes("/") ? filter.split("/") : []

    return {
        citySlug: routeCity || cityFromFilter || routeFilter,
        filterSlug: routeCity ? routeFilter : slugFromFilter || routeFilter,
    }
}
